const HEALTH_STYLES: Record<string, string> = {
  healthy: 'bg-success',
  degraded: 'bg-warning',
  unhealthy: 'bg-error',
};

export function HealthStatusIndicator({ status }: { status: string | null }) {
  if (!status) return <span className="inline-block h-2.5 w-2.5 rounded-full bg-muted-foreground" title="No health data" />;
  const style = HEALTH_STYLES[status] || 'bg-muted-foreground';
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${style}`} title={status} />;
}
